/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDriverEvents.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/driver-events";

export class AutogenModelDriverEvents<RowType extends ModelRow> extends Endpoint<RowType, RowDriverEventsFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDriverEvents extends ModelRow<RowDriverEventsFields> {
	constructor(values?: Partial<RowDriverEventsFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDriverEventsFields {
	city: string;
	city_id: number;
	company_id: string;
	"driver.ace_id": string;
	"driver.address": string;
	"driver.alert": string;
	"driver.allow_trailer_drop": string;
	"driver.avl_as_of_date": Date;
	"driver.avl_drive_hours": number;
	"driver.avl_hours": number;
	"driver.avl_onduty_hours": number;
	"driver.base_term1": string;
	"driver.base_term2": string;
	"driver.base_zip1": string;
	"driver.base_zip2": string;
	"driver.birth_date": Date;
	"driver.bseg": string;
	"driver.can_rehire": string;
	"driver.capcreat_filter": string;
	"driver.cb": string;
	"driver.cell_phone": string;
	"driver.chain_pref_1": string;
	"driver.chain_pref_1_value": number;
	"driver.chain_pref_2": string;
	"driver.chain_pref_2_value": number;
	"driver.choice_allocation": string;
	"driver.choice_commodity": string;
	"driver.choice_commodity_exclude": string;
	"driver.choice_customer": string;
	"driver.choice_equip_type": string;
	"driver.choice_exclude_hazmat": string;
	"driver.choice_order_type": string;
	"driver.choice_priority1": string;
	"driver.choice_priority1_value": number;
	"driver.choice_priority2": string;
	"driver.choice_priority2_value": number;
	"driver.choice_revenue": string;
	"driver.choice_review_dt": Date;
	"driver.citizen": string;
	"driver.citizen_country": string;
	"driver.city": string;
	"driver.city_id": number;
	"driver.cmove": string;
	"driver.company_id": string;
	"driver.country_hos_rules": string;
	"driver.country_id": string;
	"driver.currenteqpgrpid": string;
	"driver.ded_rqmt_type": string;
	"driver.ded_type": string;
	"driver.disable_driver_choice": string;
	"driver.disable_feasibility": string;
	"driver.disable_remote_access": string;
	"driver.doubles_certified": string;
	"driver.dri_uid": number;
	"driver.drvr_class": string;
	"driver.ds_model_flag": string;
	"driver.eld_exempt_reason_id": string;
	"driver.email": string;
	"driver.emrg_response_date": Date;
	"driver.enable_driver_app": string;
	"driver.enable_load_choice": string;
	"driver.end_status_date": Date;
	"driver.enginedata_pwd": string;
	"driver.equipment_type_id": string;
	"driver.event_date": Date;
	"driver.event_status": string;
	"driver.exclude_allocation": string;
	"driver.exclude_commodity": string;
	"driver.exclude_customer": string;
	"driver.exclude_equip_type": string;
	"driver.exclude_feasibility": string;
	"driver.exclude_order_type": string;
	"driver.exclude_revenue": string;
	"driver.experience": string;
	"driver.first_name": string;
	"driver.fleet_manager": string;
	"driver.fmcsa_clearinghouse_date": Date;
	"driver.group_id": string;
	"driver.hazmat_certified": string;
	"driver.hazmat_date": Date;
	"driver.hire_date": Date;
	"driver.hm126c_date": Date;
	"driver.home_duration": number;
	"driver.home_location_id": string;
	"driver.id": string;
	"driver.is_active": string;
	"driver.last_34_hour_start_date": Date;
	"driver.last_break_date": Date;
	"driver.last_home_date": Date;
	"driver.last_review_date": Date;
	"driver.latitude": number;
	"driver.license_country": string;
	"driver.license_date": Date;
	"driver.license_no": string;
	"driver.license_state": string;
	"driver.logbook_required": string;
	"driver.longitude": number;
	"driver.manual_pta_update": string;
	"driver.maryland_perm_date": Date;
	"driver.max_dispatches": number;
	"driver.max_dist_loc1": number;
	"driver.max_dist_loc2": number;
	"driver.max_mi_per_day": number;
	"driver.mc_login": string;
	"driver.mc_unit_password": string;
	"driver.medical_cert_exempt": string;
	"driver.medical_cert_expire": Date;
	"driver.model_flag": string;
	"driver.mpw_driver_contact_method": string;
	"driver.mpw_driver_high": number;
	"driver.mpw_driver_low": number;
	"driver.mpw_exclude": string;
	"driver.mpw_last_contact": Date;
	"driver.mpw_num_attempts": number;
	"driver.mpw_num_orders": number;
	"driver.mvr_date": Date;
	"driver.name": string;
	"driver.name_mid_initial": string;
	"driver.name_of_spouse": string;
	"driver.next_home_date": Date;
	"driver.num_complaints": number;
	"driver.pager": string;
	"driver.passport": string;
	"driver.payee_id": string;
	"driver.personal_conveyance": string;
	"driver.phone": string;
	"driver.physical_date": Date;
	"driver.planning_comment": string;
	"driver.preferred_days_out": number;
	"driver.prev_code": string;
	"driver.primary_agency": string;
	"driver.proximity_card": string;
	"driver.pta_date": Date;
	"driver.race": string;
	"driver.reason_for_leaving": string;
	"driver.record_pta": string;
	"driver.remark": string;
	"driver.reporting_status": string;
	"driver.return_home_flag": string;
	"driver.route_through_term": string;
	"driver.safety_meet_date": Date;
	"driver.safety_topic": string;
	"driver.security_date": Date;
	"driver.sex": string;
	"driver.shuttle_capable": string;
	"driver.site_id": string;
	"driver.social_security_no": string;
	"driver.speed": number;
	"driver.start_status_date": Date;
	"driver.state": string;
	"driver.status_code": string;
	"driver.stop_pta_update": string;
	"driver.tanks_endorsement": string;
	"driver.team_status": string;
	"driver.tenstreet_id": string;
	"driver.termination_date": Date;
	"driver.tractor_id": string;
	"driver.trainee": string;
	"driver.type_of": string;
	"driver.violation_comment": string;
	"driver.yard_move": string;
	"driver.zip": string;
	driver_mgr_id: string;
	end_date: Date;
	entered_by: string;
	"enteredby.acct_lock_date": Date;
	"enteredby.active_date": Date;
	"enteredby.admin_user": string;
	"enteredby.agent": string;
	"enteredby.agree_fieldmarshal": Date;
	"enteredby.agree_tailor": Date;
	"enteredby.agree_tailor_ext": Date;
	"enteredby.all_contacts": string;
	"enteredby.allow_new_devices": string;
	"enteredby.alternative_user": string;
	"enteredby.ap_division_id": string;
	"enteredby.appt_sched_id": string;
	"enteredby.auth_subject": string;
	"enteredby.auto_edit_type": string;
	"enteredby.avail_tract_path": string;
	"enteredby.avail_tract_sample": string;
	"enteredby.available": string;
	"enteredby.bridge_customer_access": string;
	"enteredby.brokerage_divider": number;
	"enteredby.brokerage_planning": string;
	"enteredby.brokerage_planning2": string;
	"enteredby.brokerage_planning3": string;
	"enteredby.brokerage_planning4": string;
	"enteredby.brokerage_planning_contnr": string;
	"enteredby.call_list_profile": string;
	"enteredby.carrier_call_list_id": string;
	"enteredby.carrier_mgr_profil": string;
	"enteredby.carrier_mgr_profil2": string;
	"enteredby.carrier_mgr_profil3": string;
	"enteredby.carrier_mgr_profil4": string;
	"enteredby.cell_phone": string;
	"enteredby.close_window": string;
	"enteredby.commission_payee_id": string;
	"enteredby.company_id": string;
	"enteredby.company_name": string;
	"enteredby.conf_cntr_template": number;
	"enteredby.conf_template": number;
	"enteredby.confirm_record": string;
	"enteredby.contact_id": string;
	"enteredby.continuous_radius": number;
	"enteredby.crm_vs_profile": string;
	"enteredby.csm_profile_id": string;
	"enteredby.csm_profile_id2": string;
	"enteredby.csm_profile_id3": string;
	"enteredby.csm_profile_id4": string;
	"enteredby.currency_reporting": string;
	"enteredby.currency_transaction": string;
	"enteredby.daily_advance_limits": string;
	"enteredby.daily_brok_profile": string;
	"enteredby.daily_snap_profile": string;
	"enteredby.date_format": string;
	"enteredby.default_search": number;
	"enteredby.default_wirecode": string;
	"enteredby.delivered_load_day": number;
	"enteredby.department_id": string;
	"enteredby.detention_profile_id": string;
	"enteredby.detention_profile_id2": string;
	"enteredby.detention_profile_id3": string;
	"enteredby.detention_profile_id4": string;
	"enteredby.disp_new_order_screen": string;
	"enteredby.distance_calc_vendor": string;
	"enteredby.dock_enable_wfmd_mode_swtch": string;
	"enteredby.dock_login_id": string;
	"enteredby.dragndrop_profile_id": string;
	"enteredby.driver_manager_profile": string;
	"enteredby.driver_manager_profile2": string;
	"enteredby.driver_manager_profile3": string;
	"enteredby.driver_manager_profile4": string;
	"enteredby.driver_manager_vendor": string;
	"enteredby.driver_managers": string;
	"enteredby.drivers_wo_manager": string;
	"enteredby.ds_cap_profile": string;
	"enteredby.ds_mv_eta_profile": string;
	"enteredby.ds_mv_eval_profile": string;
	"enteredby.dsp_override_user": string;
	"enteredby.email_address": string;
	"enteredby.email_bcc": string;
	"enteredby.email_client": string;
	"enteredby.email_host": string;
	"enteredby.email_imap_host": string;
	"enteredby.email_imap_password": string;
	"enteredby.email_imap_sent_folder": string;
	"enteredby.email_imap_ssl": string;
	"enteredby.email_imap_username": string;
	"enteredby.email_override_company": string;
	"enteredby.email_password": string;
	"enteredby.email_port": number;
	"enteredby.email_protocol": string;
	"enteredby.email_use_sent_folder": string;
	"enteredby.email_username": string;
	"enteredby.employee_type": string;
	"enteredby.enable_alerts": string;
	"enteredby.extension": string;
	"enteredby.external_password": string;
	"enteredby.external_user_id": string;
	"enteredby.failed_logins": number;
	"enteredby.fax": string;
	"enteredby.fileimport_profile": string;
	"enteredby.findnear_vendor": string;
	"enteredby.fleetmgmt_prof_id": string;
	"enteredby.fm_account_id": string;
	"enteredby.fm_can_view_metadata": string;
	"enteredby.fm_profile_id": string;
	"enteredby.fm_webhook_url": string;
	"enteredby.ftl_revenue_code_id": string;
	"enteredby.google_map_layer": string;
	"enteredby.google_map_type": string;
	"enteredby.grid_even_row_color": number;
	"enteredby.grid_insert_sort": string;
	"enteredby.grid_odd_row_color": number;
	"enteredby.id": string;
	"enteredby.img_category": string;
	"enteredby.inactive_date": Date;
	"enteredby.is_active": string;
	"enteredby.is_clearer": string;
	"enteredby.is_closer": string;
	"enteredby.is_dock_supervisor": string;
	"enteredby.is_dock_worker": string;
	"enteredby.is_email_confirmed": string;
	"enteredby.is_mcleod": string;
	"enteredby.issue_atm_cash": string;
	"enteredby.lock_status": string;
	"enteredby.log_sql": string;
	"enteredby.login_id": string;
	"enteredby.ltl_carrier_brk_status": string;
	"enteredby.ltl_mapping_vendor": string;
	"enteredby.ltl_quote_template": number;
	"enteredby.manifest_profile": string;
	"enteredby.margin_percentage": number;
	"enteredby.max_payment_code_amt": number;
	"enteredby.max_payment_code_amt_c": string;
	"enteredby.max_payment_code_amt_d": Date;
	"enteredby.max_payment_code_amt_n": number;
	"enteredby.max_payment_code_amt_r": number;
	"enteredby.mc_position_vendor": string;
	"enteredby.menu_tree_view": string;
	"enteredby.mfa_device_id": string;
	"enteredby.mfa_last_prompted": Date;
	"enteredby.mfa_secret": string;
	"enteredby.mfa_status": string;
	"enteredby.mobcomm_profile_id": string;
	"enteredby.mobile_pw_reset_token": string;
	"enteredby.mobile_pw_token_expire_ms": number;
	"enteredby.move_dates": string;
	"enteredby.movement_map_vendor": string;
	"enteredby.name": string;
	"enteredby.notification": string;
	"enteredby.notify_alerts": string;
	"enteredby.notify_frequency": string;
	"enteredby.notify_method": string;
	"enteredby.notify_occurance": string;
	"enteredby.operations_user_id": string;
	"enteredby.order_mode": string;
	"enteredby.order_planning2": string;
	"enteredby.order_planning3": string;
	"enteredby.order_planning4": string;
	"enteredby.order_planning_vendor": string;
	"enteredby.order_tran_request": string;
	"enteredby.orderhist_profile": string;
	"enteredby.outbound_notification": string;
	"enteredby.override_vendor_division": string;
	"enteredby.payee_id": string;
	"enteredby.pbw_brokerage_planning": string;
	"enteredby.phone": string;
	"enteredby.planner": string;
	"enteredby.planning": string;
	"enteredby.planning_container": string;
	"enteredby.planning_divider": number;
	"enteredby.primary_agency": string;
	"enteredby.prompt_cont_moves": string;
	"enteredby.quote_comp_act_create": string;
	"enteredby.quote_comp_act_id": string;
	"enteredby.quote_pend_act_create": string;
	"enteredby.quote_pend_act_id": string;
	"enteredby.quote_template": number;
	"enteredby.rapid_alert_expand": string;
	"enteredby.rapid_alert_sound": string;
	"enteredby.receive_alerts": string;
	"enteredby.recruiting_profile": string;
	"enteredby.request_location_vendor": string;
	"enteredby.revenue_code_id": string;
	"enteredby.route_detail_vendor": string;
	"enteredby.save_screen_sizes": string;
	"enteredby.search_history_limit": number;
	"enteredby.sec_ans1": string;
	"enteredby.sec_ans2": string;
	"enteredby.sec_question1": number;
	"enteredby.sec_question2": number;
	"enteredby.seg_alloc_code": string;
	"enteredby.sel_text_on_focus": string;
	"enteredby.show_active": string;
	"enteredby.show_google_route": string;
	"enteredby.show_inactive": string;
	"enteredby.single_point_vendor": string;
	"enteredby.support_inactivate_date": Date;
	"enteredby.system_tray": string;
	"enteredby.table_even_row_color": string;
	"enteredby.table_odd_row_color": string;
	"enteredby.telephony_access_token": string;
	"enteredby.telephony_access_token_exp": Date;
	"enteredby.telephony_number": string;
	"enteredby.telephony_password": string;
	"enteredby.telephony_refresh_token": string;
	"enteredby.telephony_refresh_token_exp": Date;
	"enteredby.terminal_id": string;
	"enteredby.time_format": string;
	"enteredby.token_key": number;
	"enteredby.toolbar_multi_rows": string;
	"enteredby.toolbar_setting": string;
	"enteredby.trailer_loan_profile_id": string;
	"enteredby.trailer_wash_loc": string;
	"enteredby.trailer_wash_user": string;
	"enteredby.trimble_map_traffic": string;
	"enteredby.tw_seg_code": string;
	"enteredby.tw_ticket_template": number;
	"enteredby.type_agents": string;
	"enteredby.type_carrier": string;
	"enteredby.type_company_drs": string;
	"enteredby.type_number": string;
	"enteredby.type_owner_oper": string;
	"enteredby.user_group": string;
	"enteredby.vendor_user_id": string;
	"enteredby.view_movement_vendor": string;
	"enteredby.waterfall_default_rt_guide": string;
	"enteredby.waterfall_include_rates": string;
	"enteredby.waterfall_include_rt_guides": string;
	"enteredby.waterfall_prevent_tendering": string;
	"enteredby.web_acct_status": string;
	"enteredby.web_agent": string;
	"enteredby.web_created_on": Date;
	"enteredby.web_enabled_on": Date;
	"enteredby.web_last_login": Date;
	"enteredby.web_locked_on": Date;
	"enteredby.web_map": string;
	"enteredby.web_password": string;
	"enteredby.web_user_id": string;
	"enteredby.web_user_type": string;
	"enteredby.window_location": string;
	"enteredby.windows_login": string;
	"enteredby.wire_trans_per_day": number;
	"enteredby.zone_mapping_vendor": string;
	entry_date: Date;
	equipment_id: string;
	equipment_type_id: string;
	"equipstatuscode.allow_blank_pta": string;
	"equipstatuscode.allow_dispatch": string;
	"equipstatuscode.auto_close_days": number;
	"equipstatuscode.code": string;
	"equipstatuscode.company_id": string;
	"equipstatuscode.descr": string;
	"equipstatuscode.equip_type": string;
	"equipstatuscode.msg_warning_days": number;
	"equipstatuscode.priority": string;
	event_code: string;
	event_status: string;
	id: string;
	"location.address1": string;
	"location.address2": string;
	"location.appt_required": string;
	"location.assigned_to": string;
	"location.bseg": string;
	"location.category": string;
	"location.cbsa_port_id": string;
	"location.chassis_owner": string;
	"location.chassis_pool": string;
	"location.city_id": number;
	"location.city_name": string;
	"location.class_rqmt": string;
	"location.comments": string;
	"location.company_id": string;
	"location.container_pool": string;
	"location.container_vendor": string;
	"location.cust_id": string;
	"location.customer_id": string;
	"location.days_between_calls": number;
	"location.ded_rqmt_type": string;
	"location.ded_type": string;
	"location.def_commodity_desc": string;
	"location.def_commodity_id": string;
	"location.delivery_date_option": string;
	"location.directions": string;
	"location.disable_loc_rating": string;
	"location.dl_gen_cost": number;
	"location.dl_gen_repower": number;
	"location.dl_haz_cost": number;
	"location.dl_haz_repower": number;
	"location.dl_hvl_cost": number;
	"location.dl_hvl_repower": number;
	"location.dl_load_time": number;
	"location.dl_svc_cost": number;
	"location.dl_svc_repower": number;
	"location.dl_unload_time": number;
	"location.driver_load_id": string;
	"location.driver_unload_id": string;
	"location.ds_capacity_cost": number;
	"location.ds_model_flag": string;
	"location.extra_handling_time": number;
	"location.filer_code": string;
	"location.foreign_port": string;
	"location.friday_close": Date;
	"location.friday_open": Date;
	"location.fuel_price_region": string;
	"location.google_place_fm_address": string;
	"location.google_place_id": string;
	"location.google_place_type": string;
	"location.id": string;
	"location.include_xref_trailers": string;
	"location.insur_amt_rqrd": number;
	"location.insur_amt_rqrd_c": string;
	"location.insur_amt_rqrd_d": Date;
	"location.insur_amt_rqrd_n": number;
	"location.insur_amt_rqrd_r": number;
	"location.is_active": string;
	"location.is_consignee": string;
	"location.is_customer": string;
	"location.is_customs_broker": string;
	"location.is_dist_center": string;
	"location.is_dl_gen": string;
	"location.is_dl_haz": string;
	"location.is_dl_hvl": string;
	"location.is_dl_svc": string;
	"location.is_drop_yard": string;
	"location.is_geocoded": string;
	"location.is_outside_terminal": string;
	"location.is_prospect": string;
	"location.is_remote_terminal": string;
	"location.is_shipper": string;
	"location.is_steamship": string;
	"location.is_terminal": string;
	"location.is_trailer_pool": string;
	"location.is_trailer_wash": string;
	"location.is_truckstop": string;
	"location.last_used_date": Date;
	"location.latitude": number;
	"location.layover": string;
	"location.load_unload_count": number;
	"location.load_unload_excl": string;
	"location.load_unload_param": string;
	"location.loading_instructs": string;
	"location.loading_time": number;
	"location.longitude": number;
	"location.ltl_optimize_time_per_spot": number;
	"location.ltl_seg_alloc_code": string;
	"location.manual_exchange": string;
	"location.max_drvr_complaint": number;
	"location.max_pallet_balance": number;
	"location.max_payment_code_amt": number;
	"location.max_payment_code_amt_c": string;
	"location.max_payment_code_amt_d": Date;
	"location.max_payment_code_amt_n": number;
	"location.max_payment_code_amt_r": number;
	"location.model_flag": string;
	"location.monday_close": Date;
	"location.monday_open": Date;
	"location.name": string;
	"location.need_clean_trailer": string;
	"location.next_call_date": Date;
	"location.no_fuel_radius_inbound": string;
	"location.no_fuel_radius_outbound": number;
	"location.no_stop_miles": number;
	"location.on_duty_not_driving_mins": number;
	"location.pallet_balance": number;
	"location.pallets_required": string;
	"location.payment_api_excluded": string;
	"location.pickup_date_option": string;
	"location.plc_uid": number;
	"location.pnn_city_id": number;
	"location.pnn_city_name": string;
	"location.pnn_state": string;
	"location.pnn_zip_code": string;
	"location.port_id": string;
	"location.prev_code": string;
	"location.primary_agency": string;
	"location.radius": number;
	"location.regulated": string;
	"location.reload_rqmt": string;
	"location.reserve_mins": number;
	"location.salesperson": string;
	"location.saturday_close": Date;
	"location.saturday_open": Date;
	"location.shuttle_capacity": string;
	"location.state": string;
	"location.sunday_close": Date;
	"location.sunday_open": Date;
	"location.swap_cost": number;
	"location.team_rqmt": string;
	"location.thursday_close": Date;
	"location.thursday_open": Date;
	"location.trailer_pool_min": number;
	"location.trailer_pool_radius": number;
	"location.trailer_pool_size": number;
	"location.trailer_wash_vend": string;
	"location.trimble_place_id": string;
	"location.trip_starter": string;
	"location.tuesday_close": Date;
	"location.tuesday_open": Date;
	"location.tw_seg_code": string;
	"location.unload_instructs": string;
	"location.unloading_time": number;
	"location.website_url": string;
	"location.wednesday_close": Date;
	"location.wednesday_open": Date;
	"location.zip_code": string;
	location_id: string;
	notify_end_date: Date;
	notify_start_date: Date;
	priority: string;
	remark: string;
	request_date: Date;
	start_date: Date;
	state: string;
	"users.acct_lock_date": Date;
	"users.active_date": Date;
	"users.admin_user": string;
	"users.agent": string;
	"users.agree_fieldmarshal": Date;
	"users.agree_tailor": Date;
	"users.agree_tailor_ext": Date;
	"users.all_contacts": string;
	"users.allow_new_devices": string;
	"users.alternative_user": string;
	"users.ap_division_id": string;
	"users.appt_sched_id": string;
	"users.auth_subject": string;
	"users.auto_edit_type": string;
	"users.avail_tract_path": string;
	"users.avail_tract_sample": string;
	"users.available": string;
	"users.bridge_customer_access": string;
	"users.brokerage_divider": number;
	"users.brokerage_planning": string;
	"users.brokerage_planning2": string;
	"users.brokerage_planning3": string;
	"users.brokerage_planning4": string;
	"users.brokerage_planning_contnr": string;
	"users.call_list_profile": string;
	"users.carrier_call_list_id": string;
	"users.carrier_mgr_profil": string;
	"users.carrier_mgr_profil2": string;
	"users.carrier_mgr_profil3": string;
	"users.carrier_mgr_profil4": string;
	"users.cell_phone": string;
	"users.close_window": string;
	"users.commission_payee_id": string;
	"users.company_id": string;
	"users.company_name": string;
	"users.conf_cntr_template": number;
	"users.conf_template": number;
	"users.confirm_record": string;
	"users.contact_id": string;
	"users.continuous_radius": number;
	"users.crm_vs_profile": string;
	"users.csm_profile_id": string;
	"users.csm_profile_id2": string;
	"users.csm_profile_id3": string;
	"users.csm_profile_id4": string;
	"users.currency_reporting": string;
	"users.currency_transaction": string;
	"users.daily_advance_limits": string;
	"users.daily_brok_profile": string;
	"users.daily_snap_profile": string;
	"users.date_format": string;
	"users.default_search": number;
	"users.default_wirecode": string;
	"users.delivered_load_day": number;
	"users.department_id": string;
	"users.detention_profile_id": string;
	"users.detention_profile_id2": string;
	"users.detention_profile_id3": string;
	"users.detention_profile_id4": string;
	"users.disp_new_order_screen": string;
	"users.distance_calc_vendor": string;
	"users.dock_enable_wfmd_mode_swtch": string;
	"users.dock_login_id": string;
	"users.dragndrop_profile_id": string;
	"users.driver_manager_profile": string;
	"users.driver_manager_profile2": string;
	"users.driver_manager_profile3": string;
	"users.driver_manager_profile4": string;
	"users.driver_manager_vendor": string;
	"users.driver_managers": string;
	"users.drivers_wo_manager": string;
	"users.ds_cap_profile": string;
	"users.ds_mv_eta_profile": string;
	"users.ds_mv_eval_profile": string;
	"users.dsp_override_user": string;
	"users.email_address": string;
	"users.email_bcc": string;
	"users.email_client": string;
	"users.email_host": string;
	"users.email_imap_host": string;
	"users.email_imap_password": string;
	"users.email_imap_sent_folder": string;
	"users.email_imap_ssl": string;
	"users.email_imap_username": string;
	"users.email_override_company": string;
	"users.email_password": string;
	"users.email_port": number;
	"users.email_protocol": string;
	"users.email_use_sent_folder": string;
	"users.email_username": string;
	"users.employee_type": string;
	"users.enable_alerts": string;
	"users.extension": string;
	"users.external_password": string;
	"users.external_user_id": string;
	"users.failed_logins": number;
	"users.fax": string;
	"users.fileimport_profile": string;
	"users.findnear_vendor": string;
	"users.fleetmgmt_prof_id": string;
	"users.fm_account_id": string;
	"users.fm_can_view_metadata": string;
	"users.fm_profile_id": string;
	"users.fm_webhook_url": string;
	"users.ftl_revenue_code_id": string;
	"users.google_map_layer": string;
	"users.google_map_type": string;
	"users.grid_even_row_color": number;
	"users.grid_insert_sort": string;
	"users.grid_odd_row_color": number;
	"users.id": string;
	"users.img_category": string;
	"users.inactive_date": Date;
	"users.is_active": string;
	"users.is_clearer": string;
	"users.is_closer": string;
	"users.is_dock_supervisor": string;
	"users.is_dock_worker": string;
	"users.is_email_confirmed": string;
	"users.is_mcleod": string;
	"users.issue_atm_cash": string;
	"users.lock_status": string;
	"users.log_sql": string;
	"users.login_id": string;
	"users.ltl_carrier_brk_status": string;
	"users.ltl_mapping_vendor": string;
	"users.ltl_quote_template": number;
	"users.manifest_profile": string;
	"users.margin_percentage": number;
	"users.max_payment_code_amt": number;
	"users.max_payment_code_amt_c": string;
	"users.max_payment_code_amt_d": Date;
	"users.max_payment_code_amt_n": number;
	"users.max_payment_code_amt_r": number;
	"users.mc_position_vendor": string;
	"users.menu_tree_view": string;
	"users.mfa_device_id": string;
	"users.mfa_last_prompted": Date;
	"users.mfa_secret": string;
	"users.mfa_status": string;
	"users.mobcomm_profile_id": string;
	"users.mobile_pw_reset_token": string;
	"users.mobile_pw_token_expire_ms": number;
	"users.move_dates": string;
	"users.movement_map_vendor": string;
	"users.name": string;
	"users.notification": string;
	"users.notify_alerts": string;
	"users.notify_frequency": string;
	"users.notify_method": string;
	"users.notify_occurance": string;
	"users.operations_user_id": string;
	"users.order_mode": string;
	"users.order_planning2": string;
	"users.order_planning3": string;
	"users.order_planning4": string;
	"users.order_planning_vendor": string;
	"users.order_tran_request": string;
	"users.orderhist_profile": string;
	"users.outbound_notification": string;
	"users.override_vendor_division": string;
	"users.payee_id": string;
	"users.pbw_brokerage_planning": string;
	"users.phone": string;
	"users.planner": string;
	"users.planning": string;
	"users.planning_container": string;
	"users.planning_divider": number;
	"users.primary_agency": string;
	"users.prompt_cont_moves": string;
	"users.quote_comp_act_create": string;
	"users.quote_comp_act_id": string;
	"users.quote_pend_act_create": string;
	"users.quote_pend_act_id": string;
	"users.quote_template": number;
	"users.rapid_alert_expand": string;
	"users.rapid_alert_sound": string;
	"users.receive_alerts": string;
	"users.recruiting_profile": string;
	"users.request_location_vendor": string;
	"users.revenue_code_id": string;
	"users.route_detail_vendor": string;
	"users.save_screen_sizes": string;
	"users.search_history_limit": number;
	"users.sec_ans1": string;
	"users.sec_ans2": string;
	"users.sec_question1": number;
	"users.sec_question2": number;
	"users.seg_alloc_code": string;
	"users.sel_text_on_focus": string;
	"users.show_active": string;
	"users.show_google_route": string;
	"users.show_inactive": string;
	"users.single_point_vendor": string;
	"users.support_inactivate_date": Date;
	"users.system_tray": string;
	"users.table_even_row_color": string;
	"users.table_odd_row_color": string;
	"users.telephony_access_token": string;
	"users.telephony_access_token_exp": Date;
	"users.telephony_number": string;
	"users.telephony_password": string;
	"users.telephony_refresh_token": string;
	"users.telephony_refresh_token_exp": Date;
	"users.terminal_id": string;
	"users.time_format": string;
	"users.token_key": number;
	"users.toolbar_multi_rows": string;
	"users.toolbar_setting": string;
	"users.trailer_loan_profile_id": string;
	"users.trailer_wash_loc": string;
	"users.trailer_wash_user": string;
	"users.trimble_map_traffic": string;
	"users.tw_seg_code": string;
	"users.tw_ticket_template": number;
	"users.type_agents": string;
	"users.type_carrier": string;
	"users.type_company_drs": string;
	"users.type_number": string;
	"users.type_owner_oper": string;
	"users.user_group": string;
	"users.vendor_user_id": string;
	"users.view_movement_vendor": string;
	"users.waterfall_default_rt_guide": string;
	"users.waterfall_include_rates": string;
	"users.waterfall_include_rt_guides": string;
	"users.waterfall_prevent_tendering": string;
	"users.web_acct_status": string;
	"users.web_agent": string;
	"users.web_created_on": Date;
	"users.web_enabled_on": Date;
	"users.web_last_login": Date;
	"users.web_locked_on": Date;
	"users.web_map": string;
	"users.web_password": string;
	"users.web_user_id": string;
	"users.web_user_type": string;
	"users.window_location": string;
	"users.windows_login": string;
	"users.wire_trans_per_day": number;
	"users.zone_mapping_vendor": string;
	zip_code: string;
}

